// 获取域名环境
export const getENVType = () => {
    const base_url = require('../../../public/config')
    let type = base_url.type
    let url = base_url.host
    let s3 = base_url.s3
    return { type, url, s3 }
  }